module.exports = __webpack_public_path__ + "img/SU2M3_new.5108195c.jpg";